import tokens from 'bundle-text:@atlas-ui/tokens/dist/css/main.css';
import legacyTokens from 'bundle-text:@atlas-ui/tokens/dist/tokens.css';
import { Global, css } from '@emotion/react';

const oldTokensStyle = css(legacyTokens);
const tokensStyle = css(tokens);

export const TokensGlobalStyle = () => {
  return <Global styles={[oldTokensStyle, tokensStyle]} />;
};
